import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import RegisterView from '../views/RegisterView.vue'
import RegisterConfirmationView from '../views/RegisterConfirmationView.vue'
import LicensesView from '../views/LicensesView.vue'
import MyProfileView from '../views/MyProfileView.vue'
import UpdateEmailConfirmationView from '../views/UpdateEmailConfirmationView.vue'
import AccessSharingConfirmationView from '../views/AccessSharingConfirmationView.vue'
import ApplicationBaseView from '../views/ApplicationBaseView.vue'
import ApplicationLoginView from '../views/ApplicationLoginView.vue'
import ApplicationLicensesView from '../views/ApplicationLicensesView.vue'
import ApplicationMigrationView from '../views/ApplicationMigrationView.vue'
import ApplicationHelpView from '../views/ApplicationHelpView.vue'
import AuthorizationLoginView from '../views/AuthorizationLoginView.vue'
import AuthorizationRegisterView from '../views/AuthorizationRegisterView.vue'
import PageNotFoundView from '../views/PageNotFoundView.vue'

const routes = [
  {
    path: `/`,
    name: 'Home',
    component: HomeView
  },
  {
    path: `/login`,
    name: 'Log In',
    component: LoginView
  },
  {
    path: `/reset-password`,
    name: 'Reset Password',
    component: ResetPasswordView,
    props: route => ({ token: route.query.token })
  },
  {
    path: `/register`,
    name: 'Register',
    component: RegisterView,
    props: route => ({ invitation: route.query.invitation })
  },
  {
    path: `/register-confirm`,
    name: 'Register Confirmation',
    component: RegisterConfirmationView,
    props: route => ({ token: route.query.token, invitation: route.query.invitation })
  },
  {
    path: `/licenses`,
    name: 'Licenses',
    component: LicensesView
  },
  {
    path: `/profile`,
    name: 'My Profile',
    component: MyProfileView
  },
  {
    path: `/update-email-confirm`,
    name: 'Update Email Confirmation',
    component: UpdateEmailConfirmationView,
    props: route => ({ token: route.query.token })
  },
  {
    path: `/access-sharing-confirm`,
    name: 'Access Sharing Confirmation',
    component: AccessSharingConfirmationView,
    props: route => ({ invitation: route.query.invitation })
  },
  {
    path: `/application`,
    name: 'Application',
    component: ApplicationBaseView
  },
  {
    path: `/application/login`,
    name: 'Application Login',
    component: ApplicationLoginView
  },
  {
    path: `/application/licenses`,
    name: 'Application Licenses',
    component: ApplicationLicensesView
  },
  {
    path: `/application/migration`,
    name: 'Application Migration',
    component: ApplicationMigrationView
  },
  {
    path: `/application/help`,
    name: 'Application Help',
    component: ApplicationHelpView
  },
  {
    path: `/authorization/login`,
    name: 'Authorization Login',
    component: AuthorizationLoginView,
    props: route => ({ session_uid: route.query.session_uid })
  },
  {
    path: `/authorization/register`,
    name: 'Authorization Register',
    component: AuthorizationRegisterView,
    props: route => ({ session_uid: route.query.session_uid })
  },
  {
    path: `/:catchAll(.*)*`,
    name: "PageNotFoundView",
    component: PageNotFoundView,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

/*
// ONLY FOR DEV... => Make sure there is a certain path for the dev
const kActivationServerDevPath = "/dev123"
router.beforeEach((to, from, next) => {
  if (to.path.startsWith(kActivationServerDevPath)) {
    const newPath = to.path.replace(kActivationServerDevPath, '');
    next({
      path: newPath,
      query: to.query,
      hash: to.hash
     });
  } else {
    next();
  }
})
  */

export default router
